const setNguoiDung = (nguoiDung) => {
    return {
        type: "SET_USER",
        payload: nguoiDung
    }
}

export default {
    setNguoiDung
  
}